export default __webpack_public_path__ + "static/media/Torpedo-3Open.fe1bcf12.jpg";